import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { HpTag, Icon, TableScroll } from '@hp/ui';
import { projectFileUrl, type ProjectListItem } from './queries';
import { RelativeTime } from '../../components/relative-time';
import { BrutTable, BrutTheadRow } from '../../components/ui/table';

export function ProjectTable({ projects, isLoading }: { projects: ProjectListItem[]; isLoading: boolean }) {
  const { t } = useTranslation(['projects', 'common']);
  const navigate = useNavigate();

  return (
    <section className="hp-card">
      <TableScroll label={t('table.label')}>
        <BrutTable>
          <BrutTheadRow>
            <th aria-label={t('table.cover')} />
            <th>{t('common:table.name')}</th>
            <th>{t('common:table.address')}</th>
            <th className="bo-cell-num">{t('table.units')}</th>
            <th className="bo-cell-num">{t('table.photos')}</th>
            <th>{t('table.completion')}</th>
            <th>{t('common:table.updated')}</th>
          </BrutTheadRow>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={7} className="bo-cell-empty">
                  {t('common:actions.loading')}
                </td>
              </tr>
            )}
            {!isLoading && projects.length === 0 && (
              <tr>
                <td colSpan={7} className="bo-cell-empty">
                  {t('table.empty')}
                </td>
              </tr>
            )}
            {projects.map((p) => (
              <tr key={p.id} className="bo-row--link" onClick={() => void navigate(`/projects/${p.id}`)}>
                <td className="bo-cell-thumb">
                  {p.coverFileId !== null ? (
                    <img src={projectFileUrl(p.coverFileId)} alt="" className="bo-thumb" />
                  ) : (
                    <span className="bo-thumb bo-thumb--empty" aria-hidden="true">
                      <Icon name="image" />
                    </span>
                  )}
                </td>
                <td>
                  <span className="bo-row">
                    <span className="bo-strong">{p.name}</span>
                    {p.pendingChanges > 0 && (
                      <HpTag tone="warning" title={t('table.pendingChangesTitle', { count: p.pendingChanges })}>
                        {t('table.pendingChanges', { count: p.pendingChanges })}
                      </HpTag>
                    )}
                  </span>
                </td>
                <td className="bo-cell-muted">{p.address ?? '—'}</td>
                <td className="bo-cell-num">
                  {p.numberOfUnits ?? p.unitCount}
                  {p.numberOfUnits === null && (
                    <span className="bo-muted" title={t('table.liveCount')}>
                      {' '}
                      *
                    </span>
                  )}
                </td>
                <td className="bo-cell-num bo-cell-muted">{p.photoCount}</td>
                <td>{p.yearOfCompletion ?? <span className="bo-muted">—</span>}</td>
                <td className="bo-cell-muted">
                  <RelativeTime value={p.updatedAt} />
                </td>
              </tr>
            ))}
          </tbody>
        </BrutTable>
      </TableScroll>
    </section>
  );
}
